import { ScreeningAnswer, ScreeningQuestionType, ScreeningTemplateType } from "@prisma/client"
import FreeTextQuestionResponse from "./FreeTextQuestionResponse"
import { getDateLocaleFormat } from "utils"
import ScreeningQuestionResponse from "./ScreeningQuestionResponse"
import MultipleChoiceQuestionResponse from "./MultipleChoiceQuestionResponse"
import MinutesQuestionResponse from "./MinutesQuestionResponse"
import PercentageQuestionResponse from "./PercentageQuestionResponse"
import ScaleQuestionResponse from "./ScaleQuestionResponse"
import YesNoQuestionResponse from "./YesNoQuestionResponse"
import ScaleSliderQuestionResponse from "./ScaleSliderQuestionResponse"
import { TypographyV2 } from "components/v2"
import QuestionnaireResponse from "./QuestionnaireResponse"
import CardQuestionnaireResponse from "./CardQuestionnaireResponse"
import GuidelineCard from "components/v2/components/WebBasedEvent/WebBasedEventContent/WebBasedEventCardContent/GuidelineCard"

export const getQuestionResponseComponent = (
    question: any,
    screeningAnswer: ScreeningAnswer,
    index: number,
    dateFormat: string,
    i18n: any,
    screeningAnswers: ScreeningAnswer[],
    useQuestionnaireView: boolean = false,
    screeningType?: ScreeningTemplateType
) => {
    switch (question.type) {
        case ScreeningQuestionType.free_text:
        case ScreeningQuestionType.number:
            return (
                <FreeTextQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.time_of_day:
            const timeOfDayAnswer = screeningAnswer?.value?.slice(0, 5)

            return (
                <FreeTextQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={{ ...screeningAnswer, value: timeOfDayAnswer }}
                />
            )
        case ScreeningQuestionType.select:
            return (
                <ScreeningQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.multiple_choice:
            return (
                <MultipleChoiceQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.minutes:
            return (
                <MinutesQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.percent:
            return (
                <PercentageQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.scale:
            return (
                <ScaleQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.yes_no:
            return (
                <YesNoQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.scale_slider:
            return (
                <ScaleSliderQuestionResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswer={screeningAnswer}
                />
            )
        case ScreeningQuestionType.text_only:
            return (
                <div key={`buildIntakeFormResponse_${index}`} className="mt-6">
                    <TypographyV2 type="sm" width="bold" className="font-bold">
                        {question?.question}
                    </TypographyV2>
                </div>
            )
        case ScreeningQuestionType.guideline:
            return <GuidelineCard key={`buildIntakeFormResponse_${index}`} description={question?.question} />
        case ScreeningQuestionType.questionnaire:
            return useQuestionnaireView ? (
                <CardQuestionnaireResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswers={screeningAnswers.find(
                        (answer) => answer.questionnaire_id === question.definition.questionnaire_id
                    )}
                />
            ) : (
                <QuestionnaireResponse
                    key={`buildIntakeFormResponse_${index}`}
                    question={question}
                    screeningAnswers={screeningAnswers.find(
                        (answer) => answer.questionnaire_id === question.definition.questionnaire_id
                    )}
                    screeningType={screeningType}
                />
            )
    }
}
